<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.2969 5.67188H17.9531V1.5C17.9531 1.11169 17.6383 0.796875 17.25 0.796875H0.703125C0.314812 0.796875 0 1.11169 0 1.5V19.6875C0 21.626 1.57711 23.2031 3.51562 23.2031H20.4844C22.4229 23.2031 24 21.626 24 19.6875V6.375C24 5.98669 23.6852 5.67188 23.2969 5.67188ZM3.51562 21.7969C2.35252 21.7969 1.40625 20.8506 1.40625 19.6875V2.20312H16.5469C16.5469 20.7875 16.538 19.7542 16.563 20.0192C16.6241 20.6711 16.8672 21.2857 17.2516 21.7969H3.51562ZM22.5938 19.6875C22.5938 20.8506 21.6475 21.7969 20.4844 21.7969C20.3266 21.7969 20.2174 21.7969 20.0625 21.7969C18.8994 21.7969 17.9531 20.8506 17.9531 19.6875V7.07812H22.5938V19.6875Z"
  />
  <path
    d="M14.25 4.17188H3.75C3.36169 4.17188 3.04688 4.48669 3.04688 4.875C3.04688 5.26331 3.36169 5.57812 3.75 5.57812H14.25C14.6383 5.57812 14.9531 5.26331 14.9531 4.875C14.9531 4.48669 14.6383 4.17188 14.25 4.17188Z"
  />
  <path
    d="M14.25 7.17188H3.75C3.36169 7.17188 3.04688 7.48669 3.04688 7.875C3.04688 8.26331 3.36169 8.57812 3.75 8.57812H14.25C14.6383 8.57812 14.9531 8.26331 14.9531 7.875C14.9531 7.48669 14.6383 7.17188 14.25 7.17188Z"
  />
  <path
    d="M14.25 18.4219H3.75C3.36169 18.4219 3.04688 18.7367 3.04688 19.125C3.04688 19.5133 3.36169 19.8281 3.75 19.8281H14.25C14.6383 19.8281 14.9531 19.5133 14.9531 19.125C14.9531 18.7367 14.6383 18.4219 14.25 18.4219Z"
  />
  <path
    d="M14.25 10.1719H9C8.61169 10.1719 8.29688 10.4867 8.29688 10.875V16.125C8.29688 16.5133 8.61169 16.8281 9 16.8281H14.25C14.6383 16.8281 14.9531 16.5133 14.9531 16.125V10.875C14.9531 10.4867 14.6383 10.1719 14.25 10.1719ZM13.5469 15.4219H9.70312V11.5781H13.5469V15.4219Z"
  />
  <path
    d="M3.75 12.7031H6C6.38831 12.7031 6.70312 12.3883 6.70312 12C6.70312 11.6117 6.38831 11.2969 6 11.2969H3.75C3.36169 11.2969 3.04688 11.6117 3.04688 12C3.04688 12.3883 3.36169 12.7031 3.75 12.7031Z"
  />
  <path
    d="M3.75 15.7031H6C6.38831 15.7031 6.70312 15.3883 6.70312 15C6.70312 14.6117 6.38831 14.2969 6 14.2969H3.75C3.36169 14.2969 3.04688 14.6117 3.04688 15C3.04688 15.3883 3.36169 15.7031 3.75 15.7031Z"
  />
</svg>
